import { Typography } from '@mui/material';
import React from 'react';

const CadrageTitle = ({ text }: { text: string }): React.ReactElement => (
    <Typography
        variant="h4"
        sx={{
            color: 'primary.main',
            mb: '1rem',
        }}
    >
        {text}
    </Typography>
);

export default CadrageTitle;
